import { z } from "zod/v4";

const timeRangeSchema = z.object({
  start: z
    .string()
    .min(1)
    .regex(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}Z$/, {
      message: "Use ISO-8601 UTC format: YYYY-MM-DDTHH:mm:ssZ",
    }),
  end: z
    .string()
    .min(1)
    .regex(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}Z$/, {
      message: "Use ISO-8601 UTC format: YYYY-MM-DDTHH:mm:ssZ",
    }),
});

const exportTargetSchema = z.enum(["trends", "urls"]);
const exportFormatSchema = z.enum(["csv", "excel", "json"]);

const indexWorkerExportToolOutputSchema = z.object({
  context: z.object({
    targetType: z.literal("indexWorker"),
    targetId: z.string().min(1),
    indexWorkerName: z.string().min(1),
    exportTarget: exportTargetSchema,
    format: exportFormatSchema,
    dateRange: timeRangeSchema.optional(),
    isComparing: z.boolean().optional(),
    comparingDateRange: timeRangeSchema.nullable().optional(),
  }),
  exportRequest: z.object({
    indexWorkerId: z.string().min(1),
    indexWorkerName: z.string().min(1),
    exportTarget: exportTargetSchema,
    format: exportFormatSchema,
    dateRange: timeRangeSchema.nullable(),
    isComparing: z.boolean(),
    comparingDateRange: timeRangeSchema.nullable(),
  }),
});

export type IndexWorkerExportToolOutput = z.infer<
  typeof indexWorkerExportToolOutputSchema
>;

export function parseIndexWorkerExportToolOutput(
  output: unknown,
): IndexWorkerExportToolOutput | null {
  if (typeof output !== "object" || output === null) {
    return null;
  }
  const result = indexWorkerExportToolOutputSchema.safeParse(output);
  return result.success ? result.data : null;
}
